var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var GUIHandleModel  = require("./guiHandleModel.js");

var GlobalRotationHandleModel = function (editorModel, handleId, config) {
    GUIHandleModel.call(this, editorModel, handleId);
    var self = this;
    this.config = config;

    this.multipleSubjects = true;

    this.axis = new THREE.Vector3(1,0,0);

    this.lastAngle = null;
    this.lastRotation = null;

    this.snapped = this.value("snapped", true);
    this.selected = this.value("selected", true);
};

lib_core.inherit(GlobalRotationHandleModel, GUIHandleModel);
GlobalRotationHandleModel.$class = "GlobalRotationHandleModel";
module.exports = GlobalRotationHandleModel;


GlobalRotationHandleModel.prototype.getSubject = function(){
    return this.subjects.getOne(); // TODO handle group select
} 

GlobalRotationHandleModel.prototype.getSubjectsRadius = function(){
    return this.getSubject().getRadius(); // TODO handle group select
} 

GlobalRotationHandleModel.prototype.getSubjectsCenter = function(){
    return this.getSubject().getPosition(); // TODO handle group select
} 

GlobalRotationHandleModel.prototype.getSubjectsRotation = function(){
    return this.getSubject().getRotation(); // TODO handle group select
} 


GlobalRotationHandleModel.prototype.createMovementPlane = function(ray, point){
    var subject = this.getSubject();
    var newRay = new THREE.Vector3(this.axis.x , this.axis.y, this.axis.z);

    var zero = new THREE.Vector3();
    var pos = subject.getPosition();
    var vecToOrigin = new THREE.Vector3( pos.x, pos.y, pos.z );
    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

GlobalRotationHandleModel.prototype.setContactPosition = function(position){
     this.selected(true);
     
     this.lastAngle = this.getCurrentAngle(position);
     this.lastRotation = this.getSubject().getRotation();
}

GlobalRotationHandleModel.prototype.setMousePosition = function(position){
    var subject = this.getSubject();

    var newAngle = this.getCurrentAngle(position);

    var angleDelta = newAngle - this.lastAngle;
    var newRotation = this.getRotation(this.lastRotation, angleDelta);

    if(this.isSnap(newRotation)){

        var snapRotation = this.getSnap(newRotation);
        //var snapRotation = this.setMyValue(subject.getRotation(), snapVal);
        subject.setRotation(snapRotation);

        this.snapped(true);

    } else {

        subject.setRotation(newRotation);

        this.lastAngle = newAngle;
        this.lastRotation = newRotation;
        this.snapped(false);
    }
}

GlobalRotationHandleModel.prototype.isSnap = function(rotation){
    var xsnap = false;
    var ysnap = false;
    var zsnap = false;

    var xsnapval = Math.round((rotation.x)/90) * 90;
    var ysnapval = Math.round((rotation.y)/90) * 90;
    var zsnapval = Math.round((rotation.z)/90) * 90;

    if(Math.abs(rotation.x - xsnapval) < 5) xsnap = true;
    if(Math.abs(rotation.y - ysnapval) < 5) ysnap = true;
    if(Math.abs(rotation.z - zsnapval) < 5) zsnap = true;

    if(xsnap && ysnap && zsnap) return true;
    else return false;
}

GlobalRotationHandleModel.prototype.getSnap = function(rotation){
    var xsnap = Math.round((rotation.x)/90) * 90;
    var ysnap = Math.round((rotation.y)/90) * 90;
    var zsnap = Math.round((rotation.z)/90) * 90;

    return new lib_geometry.Coord3d(xsnap, ysnap, zsnap);
}

// rotate the given rotation around my axis by this delta angle, and return result
GlobalRotationHandleModel.prototype.getRotation = function(lastRotation, deltaAngle){
    var subject = this.getSubject();
    var eularRot = new THREE.Euler(lastRotation.x * Math.PI/180, lastRotation.y * Math.PI/180, lastRotation.z * Math.PI/180);

    var myMatrix = (new THREE.Matrix4()).makeRotationFromEuler(eularRot);
    var changeMatrix = (new THREE.Matrix4()).makeRotationAxis( this.axis, deltaAngle );
    myMatrix.premultiply(changeMatrix);

    var newRotation = (new THREE.Euler()).setFromRotationMatrix(myMatrix);
    var realrot = new lib_geometry.Coord3d(newRotation.x * 180/Math.PI, newRotation.y * 180/Math.PI, newRotation.z * 180/Math.PI);
    
    return realrot;
}

GlobalRotationHandleModel.prototype.released = function(){
    this.selected(false);
    this.snapped(false);
}



